import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GqlMedia } from "~/__generated__";
import MediaList from "~/modules/media/components/MediaList/MediaList";
import MediaPreviewDialog from "~/modules/media/components/MediaPreviewDialog/MediaPreviewDialog";
import RenderIf from "~/shared/components/RenderIf";

import { MapEditorPlannerAreaPanel_SettingsDisplayFragment } from "./fragments.generated";

type PlannerAreaSettingsReadOnlyProps = {
    plannerArea: MapEditorPlannerAreaPanel_SettingsDisplayFragment;
};

export function PlannerAreaSettingsReadOnly({ plannerArea }: PlannerAreaSettingsReadOnlyProps) {
    const { t } = useTranslation("mapEditor");
    const [selectedItem, setSelectedItem] = useState<GqlMedia | null>(null);

    return (
        <>
            <Stack rowGap={2} padding={2}>
                <Stack>
                    <Typography variant="caption">{t("featureDetailAreaSettings.labelName")}</Typography>
                    <Typography>{plannerArea.name}</Typography>
                </Stack>

                {plannerArea.descriptionClient && (
                    <Stack>
                        <Typography variant="caption">{t("featureDetailAreaSettings.labelDescription")}</Typography>
                        <Typography>{plannerArea.descriptionClient}</Typography>
                    </Stack>
                )}
                <RenderIf
                    payload={plannerArea.mediasClient}
                    render={medias =>
                        medias.length > 0 && (
                            <Stack>
                                <Typography variant="caption">Media</Typography>
                                <MediaList medias={medias} onMediaClick={setSelectedItem} />
                            </Stack>
                        )
                    }
                />
            </Stack>
            <MediaPreviewDialog media={selectedItem} open={selectedItem !== null} onClose={() => setSelectedItem(null)} />
        </>
    );
}
